import { FC, useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  Grid,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import PasswordStrengthIndicator from "../../helpers/PasswordStrengthIndicator";
import Textfield from "../FormsUI/Textfield";
import ButtonSubmit from "../FormsUI/Button";
import { Formik, Form } from "formik";
import view from "../../assets/images/view.svg";
import unview from "../../assets/images/unview.svg";
import * as Yup from "yup";
import AuthContext from "../../store/Auth/AuthContext";
import AlertContext from "../../store/Alert/AlertContext";
import graphQLClient from "../../utils/authHeader";
import UPDATEPASSWORD from "../../utils/mutations/updateProfile/updatePassword";

const ChangePassword: FC<any> = ({ open, setOpen }: any) => {
  const classes = useStyles();
  const theme = useTheme();
  const { RefreshTokens, Logout } = useContext<any>(AuthContext);
  const { setAlert } = useContext<any>(AlertContext);

  const handleClose = () => {
    setOpen(false);
  };

  const INITIAL_FORM_STATE = {
    currentpassword: "",
    password: "",
    repassword: "",
  };

  const FORM_VALIDATION = Yup.object().shape({
    currentpassword: Yup.string().required("Current Password Required"),
    password: Yup.string().required("Password Required"),
    repassword: Yup.string()
      .required("Password Required")
      .oneOf([Yup.ref("password"), null], "Your password doesn’t match*"),
  });

  const View = () => {
    return <img src={view} className="img-fluid" alt="Gains" />;
  };
  const Unview = () => {
    return <img src={unview} className="img-fluid " alt="Gains" />;
  };

  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const [password, setPassword] = useState({
    showPassword: false,
    showPassword2: false,
    showPassword3: false,
  });

  const handleClickShowPassword = () => {
    setPassword({ ...password, showPassword: !password.showPassword });
  };
  const handleClickShowPassword2 = () => {
    setPassword({ ...password, showPassword2: !password.showPassword2 });
  };
  const handleClickShowPassword3 = () => {
    setPassword({ ...password, showPassword3: !password.showPassword3 });
  };

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  const isNumberRegx = /\d/;
  const lowerUpperCase = /[A-Z]/;
  const isSpecialCharacter = /[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]/;
  const [passwordFocused, setPasswordFocused] = useState(false);

  let [passwordValidity, setPasswordValidity] = useState({
    specialCharacter: false,
    minChar: false,
    number: false,
    lowerUpper: false,
    invalidText: false,
  });

  let onChangePassword = (password: { password: string }) => {
    setPasswordValidity({
      specialCharacter: isSpecialCharacter.test(password.password),
      minChar: password.password.length >= 8 && password.password.length <= 36 ? true :false,
      number: isNumberRegx.test(password.password) ? true : false,
      lowerUpper: lowerUpperCase.test(password.password) ? true : false,
      invalidText: password.password.toLowerCase().includes('gains') ? false : true,
    });
  };

  const UpdatePassword = (values: {
    currentpassword: string;
    password: string;
    repassword: string;
  }) => {
    main();
    async function main() {
      const variables = {
        changePasswordInput: {
          oldPassword: values.currentpassword,
          newPassword: values.repassword,
        },
      };
      graphQLClient
        .request(UPDATEPASSWORD, variables)
        .then((data) => {
          setAlert(data.updatePassword.message, "success");
          Logout("session");
        })
        .catch((err) => {
          if (
            err?.response?.errors[0]?.extensions?.response?.statusCode === 401
          ) {
            RefreshTokens();
          } else {
            if (err?.response?.errors) {
              err?.response?.errors?.map((newerro: { message: any }) => {
                setAlert(newerro?.message, "warning");
              });
            } else {
              setAlert("Something went wrong while updating password.", "error");
            }
          }
        });
    }
  };

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
          maxWidth="md"
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 3}
          >
            <Box className="relative-box">
              {!isActive && (
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  onClick={handleClose}
                />
              )}
              <ProjectPoolHeading title1="Change " title2="Password" />
              <Box  component="span">
                <Typography variant="body1" className="fw-normal t-color ">
                  Please note that when changing your password,  ask you to <br />
                  set yourself a secure password.
                </Typography>
              </Box>

              <Box mt={isActive ? 3 : 3} mr={isActive ? 0 :4}>
                <Formik
                  initialValues={{
                    ...INITIAL_FORM_STATE,
                  }}
                  validationSchema={FORM_VALIDATION}
                  validate={onChangePassword}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    if (
                      !passwordValidity.minChar ||
                      !passwordValidity.number ||
                      !passwordValidity.lowerUpper
                    ) {
                      return;
                    }
                    UpdatePassword(values);
                  }}
                >
                  {({ values, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={isActive ? 2 : 3}>
                        <Grid item md={12} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Current Password*
                          </Typography>
                          <Textfield
                            name="currentpassword"
                            type={password.showPassword3 ? "text" : "password"}
                            placeholder="Enter current Password"
                            margin="dense"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword3}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    color="secondary"
                                  >
                                    {password.showPassword3 ? (
                                      <Unview />
                                    ) : (
                                      <View />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            New Password*
                          </Typography>
                          <Textfield
                            name="password"
                            onFocus={() => setPasswordFocused(true)}
                            value={values.password}
                            type={password.showPassword ? "text" : "password"}
                            placeholder="Enter New Password"
                            margin="dense"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    color="secondary"
                                  >
                                    {password.showPassword ? (
                                      <Unview />
                                    ) : (
                                      <View />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Typography
                            variant="subtitle1"
                            color="secondary"
                            className="fw-normal"
                          >
                            Re-enter Password*
                          </Typography>
                          <Textfield
                            name="repassword"
                            type={password.showPassword2 ? "text" : "password"}
                            placeholder="Enter Confirm Password"
                            margin="dense"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword2}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    color="secondary"
                                  >
                                    {password.showPassword2 ? (
                                      <Unview />
                                    ) : (
                                      <View />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        {passwordFocused && (
                          <Grid item md={12} xs={12}>
                            <PasswordStrengthIndicator
                              validity={passwordValidity}
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Box className="longbutton" mt={3}>
                        <ButtonSubmit>Save Changes</ButtonSubmit>
                      </Box>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default ChangePassword;
